import React from 'react';
import PropTypes from 'prop-types';
import CopycatMarcEdit from '../components/CopycatRecord/CopycatEdit/CopycatMarcEdit/CopycatMarcEdit';

function CopycatMarcEditRoute(props) {
  return <CopycatMarcEdit {...props} />;
}

CopycatMarcEditRoute.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
  }).isRequired,
  location: PropTypes.object,
};

export default CopycatMarcEditRoute;
